import { api, recaptchaSiteKey, recaptchaScriptUrl } from '../config';

const form = document.querySelector('[data-contact-request]');

if (form) {
  const recaptcha = document.createElement('script');
  recaptcha.src = recaptchaScriptUrl;
  recaptcha.async = true;
  document.head.appendChild(recaptcha);
}

const recaptchaToken = () => new Promise((resolve) => {
  let completed = false;
  let timeout;
  const finish = (token = '') => {
    if (completed) return;
    completed = true;
    clearTimeout(timeout);
    resolve(token);
  };
  timeout = setTimeout(finish, 5000);
  if (! window.grecaptcha) {
    finish();
    return;
  }
  try {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptchaSiteKey, { action: 'contact_mail' })
        .then(finish)
        .catch(() => finish());
    });
  } catch (error) {
    finish();
  }
});

const showStatus = (formElement, message) => {
  const status = formElement.querySelector('[data-contact-status]');
  status.textContent = message;
  status.hidden = false;
};

if (form) {
  const nameInput = form.elements.namedItem('name');
  const emailInput = form.elements.namedItem('email');
  const phoneInput = form.elements.namedItem('phone');
  const prefersPhoneInput = form.elements.namedItem('prefers_phone');
  const subjectInput = form.elements.namedItem('subject');
  const messageInput = form.elements.namedItem('message');
  const messageLabel = form.querySelector('[data-contact-message-label]');
  const texts = window.bpContactTexts || {};

  const updateRequiredFields = () => {
    phoneInput.required = prefersPhoneInput.checked;
    emailInput.required = ! prefersPhoneInput.checked;
  };
  prefersPhoneInput.addEventListener('change', updateRequiredFields);
  updateRequiredFields();

  const updateRequest = () => {
    const request = form.querySelector('[name="request_type"]:checked');
    messageLabel.textContent = request?.dataset.messageLabel || texts.messageDefault || 'Your message';
  };
  form.querySelectorAll('[name="request_type"]').forEach((request) => {
    request.addEventListener('change', updateRequest);
  });
  updateRequest();

  if (sessionStorage.getItem('username')) nameInput.value = sessionStorage.getItem('username');
  if (sessionStorage.getItem('user_email')) emailInput.value = sessionStorage.getItem('user_email');

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();
    const request = form.querySelector('[name="request_type"]:checked');
    const prefersPhone = prefersPhoneInput.checked;
    const subject = subjectInput.value.trim();
    const message = messageInput.value.trim();
    const status = form.querySelector('[data-contact-status]');
    status.hidden = true;

    if (! request || ! name || ! subject || (prefersPhone && ! phone) || (! prefersPhone && ! email)) {
      showStatus(form, texts.missingField || 'Please fill in the required fields.');
      return;
    }
    if (email && ! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showStatus(form, texts.invalidEmail || 'Please enter a valid e-mail address.');
      return;
    }

    const details = [
      `Request type: ${request.value}`,
      `Phone: ${phone}`,
      `Preferred contact method: ${prefersPhone ? 'phone' : 'e-mail'}`,
    ].join('\n');
    const fullMessage = `${details}${message ? `\n\n${message}` : ''}`;
    const body = new URLSearchParams({ name, email, subject, message: fullMessage });
    const controls = form.querySelectorAll('input, textarea, button');
    controls.forEach((control) => { control.disabled = true; });

    recaptchaToken().then((recaptcha) => {
        body.set('recaptchav3', recaptcha);
        const token = localStorage.getItem('api_token') || '';
        return fetch(api.contactmail.url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            ...(token ? { 'X-Auth-Token': token } : { 'X-Auth-Source': 'session' }),
          },
          body,
        });
      }).then((response) => {
        if (! response.ok) {
          const fallback = texts.error || 'Error';
          return response.json().then((data) => {
            const detail = data && typeof data.message === 'string' ? data.message : '';
            return detail ? `${fallback} : ${detail}` : fallback;
          }).catch(() => fallback).then((errorMessage) => {
            throw new Error(errorMessage);
          });
        }

        form.reset();
        updateRequest();
        updateRequiredFields();
        showStatus(form, texts.messageSent || 'Your message has been sent.');
        return null;
      }).catch((error) => {
        showStatus(form, error instanceof TypeError ? (texts.error || 'Error') : (error.message || texts.error || 'Error'));
      }).finally(() => {
        controls.forEach((control) => { control.disabled = false; });
      });
  });
}
